export function getTimeZoneString() {
    let date = new Date();
    const timeZoneOffset = date.getTimezoneOffset();
    return `${Math.sign(timeZoneOffset) == 1 ? "-" : "+"}0${Math.abs(
        timeZoneOffset / 60
    )}00`;
}